module.exports = __webpack_public_path__ + "static/media/youtube-logo.e40c511c.svg";